var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36621 14.9378L8.57129 15.7327C8.2347 16.0693 7.69043 16.0693 7.35742 15.7327L0.396484 8.77539C0.0598958 8.4388 0.0598958 7.89453 0.396484 7.56152L7.35742 0.600586C7.69401 0.263997 8.23828 0.263997 8.57129 0.600586L9.36621 1.39551C9.70638 1.73568 9.69922 2.29069 9.35189 2.6237L5.03711 6.73438H15.3281C15.8044 6.73438 16.1875 7.11751 16.1875 7.59375V8.73958C16.1875 9.21582 15.8044 9.59896 15.3281 9.59896H5.03711L9.35189 13.7096C9.7028 14.0426 9.70996 14.5977 9.36621 14.9378Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.661deac0a88cc484d1b746828714784f.svg";
export { ForwardRef as ReactComponent };